import { render, staticRenderFns } from "./StarRating.vue?vue&type=template&id=413cebba"
import script from "./StarRating.vue?vue&type=script&lang=js"
export * from "./StarRating.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gl-api/api.greenlists.com/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('413cebba')) {
      api.createRecord('413cebba', component.options)
    } else {
      api.reload('413cebba', component.options)
    }
    module.hot.accept("./StarRating.vue?vue&type=template&id=413cebba", function () {
      api.rerender('413cebba', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/StarRating.vue"
export default component.exports